'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const approximateNumber=require('approximate-number');
const Formatters=require('../../../../dist-es6/client/formatters');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');let

ThresholdStatusSummaryDirective=function(_BaseControllerBacked){_inherits(ThresholdStatusSummaryDirective,_BaseControllerBacked);function ThresholdStatusSummaryDirective(){_classCallCheck(this,ThresholdStatusSummaryDirective);return _possibleConstructorReturn(this,_BaseControllerBacked.apply(this,arguments))}_createClass(ThresholdStatusSummaryDirective,[{key:'objectBindings',get:function()
{
return['itemsByThresholdStatus'];
}},{key:'textBindings',get:function()

{
return['itemLabel'];
}},{key:'templateUrl',get:function()

{
return'/templates/directives/thresholdStatusSummaryDirective/thresholdStatusSummaryTemplate';
}},{key:'controller',get:function()

{
return ThresholdStatusSummaryController;
}}]);return ThresholdStatusSummaryDirective}(BaseControllerBackedDirective);let


ThresholdStatusSummaryController=function(){_createClass(ThresholdStatusSummaryController,null,[{key:'$inject',get:function()
{
return['$scope','$timeout'];
}}]);

function ThresholdStatusSummaryController($scope,$timeout){var _this2=this;_classCallCheck(this,ThresholdStatusSummaryController);
this._$scope=$scope;
this._$timeout=$timeout;

this.mode='total';
this.itemLabel=this.itemLabel||'Event';

this._$scope.$watch('controller.itemsByThresholdStatus',function(itemsByStatus,oldItemsByStatus){
if(_this2.totalAll&&_.exists(oldItemsByStatus)&&itemsByStatus===oldItemsByStatus){
return;
}

_this2._updateMetrics(_this2.itemsByThresholdStatus);
});

this._updateMetrics();
}ThresholdStatusSummaryController.prototype.

_updateMetrics=function _updateMetrics(){var _this3=this;let{At=[],Above=[],Below=[],NotApplicable=[]}=arguments.length>0&&arguments[0]!==void 0?arguments[0]:{};
this._$timeout(function(){
_this3.totalUnder=Below.length+NotApplicable.length;
_this3.totalNear=At.length;
_this3.totalOver=Above.length;
_this3.totalAll=_this3.totalUnder+_this3.totalNear+_this3.totalOver;

_this3.percentNear=_getCleanPercentage(_this3.totalNear,_this3.totalAll);
_this3.percentOver=_getCleanPercentage(_this3.totalOver,_this3.totalAll);

if(_this3.totalAll!==0){
const remainingPercent=Math.round(100-_.sum([
_this3.percentNear.startsWith('<')?0.5:parseInt(_this3.percentNear,10),
_this3.percentOver.startsWith('<')?0.5:parseInt(_this3.percentOver,10)]));


_this3.percentUnder=`${remainingPercent}%`;
}else{
_this3.percentUnder='--';
}

_this3.formattedTotalUnder=approximateNumber(_this3.totalUnder);
_this3.formattedTotalNear=approximateNumber(_this3.totalNear);
_this3.formattedTotalOver=approximateNumber(_this3.totalOver);
_this3.formattedTotalAll=approximateNumber(_this3.totalAll);
});
};return ThresholdStatusSummaryController}();


function _getCleanPercentage(num,total){let roundMethod=arguments.length>2&&arguments[2]!==void 0?arguments[2]:'round';
if(total===0){
return'--';
}else if(num===0){
return'0%';
}

const realPercent=num/total*100;
const amountLabel=realPercent<1?
'<1':
Math[roundMethod](realPercent);

return`${amountLabel}%`;
}


module.exports=ThresholdStatusSummaryDirective;
//# sourceMappingURL=thresholdStatusSummaryDirective.js.map
